import React, { useEffect } from "react";
import styles from "./kakaomap.module.css";

const { kakao } = window;

const Kakaomap = ({ nowLocation }) => {
  useEffect(() => {
    var container = document.getElementById("map");
    var options = {
      center: new kakao.maps.LatLng(nowLocation[1], nowLocation[2]),
      level: 3,
    };

    var map = new kakao.maps.Map(container, options);
    var markerPosition = new kakao.maps.LatLng(nowLocation[1], nowLocation[2]);
    var marker = new kakao.maps.Marker({
      position: markerPosition,
    });
    marker.setMap(map);
  }, [nowLocation]);

  return (
    <div className={styles.kakaomap_cont}>
      <div
        className={styles.map}
        id="map"
        style={{ width: "500px", height: "400px" }}
      ></div>
    </div>
  );
};

export default Kakaomap;
